// Copyright (c) Ping. All rights reserved.

export const shareLocationStrings = {
  modal: {
    title: 'Share location',
    close: 'Close',
    cancel: 'Cancel',
    share: 'Share',
    searchPlaceholder: 'Search or enter an address',
    clear: 'Clear search',
    tabStatic: 'Static pin',
    tabCurrent: 'Current location',
    nearby: 'Nearby locations',
    searchResults: 'Search results',
    useCurrent: 'Use my current location',
    resolving: 'Resolving your location…',
    noResults: 'No matching places.',
    typeToSearch: 'Type to search for a place.',
    mapPreviewLabel: 'Map preview',
    noSelection: 'Search or use your current location to preview it on the map.',
    locateMe: 'Locate me',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
  },
  live: {
    label: 'Share as live location',
    description: 'Updates your position for the selected duration.',
    title: 'Share live location',
    bodyPrefix: 'Everyone in ',
    bodySuffix: ' will see your location in real time until you stop sharing.',
    bodyFallback: 'this conversation',
    duration15m: 'For 15 minutes',
    duration1h: 'For 1 hour',
    duration8h: 'For 8 hours',
  },
  card: {
    /**
     * Privacy-preserving display label used in the in-chat bubble.
     * The card NEVER renders raw coordinates. The address (if any)
     * is a host-controlled human-readable line.
     */
    obfuscatedPoint: 'Shared a location',
    obfuscatedLive: 'Sharing live location',
    openLabel: 'Open in map',
    liveActive: 'Live until',
    liveUntilPrefix: 'Live location until ',
    stopSharing: 'Stop sharing',
    viewCurrent: 'View current location',
    viewLocation: 'View location',
    defaultPlace: 'Shared location',
  },
} as const;

export type ShareLocationStrings = typeof shareLocationStrings;
